import { OVERALL_CATEGORY, PLANNING_BY_FY_FQ } from '../../config'
import { checkProportion } from '../checkProportion'
import { getFinSobValue, IGetFinSobValueProps } from '../getFinSobValue'

export interface ICheckFinSobValues extends IGetFinSobValueProps {
  programType: string
  category: string
}

export const checkFinSobRate = (props: ICheckFinSobValues): boolean => {
  let isProportionValid = true

  const overallSettings = props.formats.filter(
    (el) =>
      el.ProgramType === props.programType &&
      el.Category === props.category &&
      (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
  )
  if (overallSettings.length) {
    const overallSetting = overallSettings[0]

    const settingsIndex = props.formats.indexOf(overallSetting)
    const fq = PLANNING_BY_FY_FQ
    const isUnits = false
    const sType = '' // sType = Total
    const isSoB = false

    const preActuals = getFinSobValue({
      ...props,

      settingsIndex,
      type: 'actuals',
      fy: props.fy - 1,
      fq,
      isUnits,
      sType,
      isSoB,
    })

    const currTargets = getFinSobValue({
      ...props,
      settingsIndex,
      type: 'targets',
      fy: props.fy,
      fq,
      isUnits,
      sType,
      isSoB,
    })

    isProportionValid = checkProportion([
      {
        item1: currTargets,
        item2: preActuals,
      },
    ])
  }

  return isProportionValid
}
